module.exports = __webpack_public_path__ + "img/assist2.9c48824d.png";